module.exports = __webpack_public_path__ + "static/img/yzm_bg_4.046a3eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yzm_bg_4.jpg
// module id = WfGW
// module chunks = 63